var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tooltip",
    { attrs: { content: _vm.content } },
    [
      _c(
        "el-tag",
        {
          class: ["mr-5", "tooltip-tag"],
          attrs: { type: _vm.type, size: _vm.size, closable: _vm.closable },
          on: {
            click: function($event) {
              return _vm.$emit("click")
            },
            close: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("span", [_vm._v(_vm._s(_vm.content))])]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }